import { PageHeader } from "./PageHeader";
import { FadeUp } from "./Reveal";

export const LegalPage = ({ title, updated, sections, testId }) => (
  <main data-testid={testId}>
    <PageHeader overline={`Last updated: ${updated}`} titleLines={[title]} />
    <section className="bg-paper border-t border-rule">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        {sections.map((s) => (
          <FadeUp key={s.n} className="mb-12">
            <h2 className="font-display text-2xl md:text-3xl tracking-tight">
              {s.n}. {s.heading}
            </h2>
            {s.blocks.map((b, i) => {
              if (b.type === "list") {
                return (
                  <ul key={i} className="mt-4 space-y-2">
                    {b.items.map((it, j) => (
                      <li key={j} className="flex gap-3 text-sm md:text-base leading-relaxed text-mute">
                        <span aria-hidden="true" className="text-terra shrink-0">—</span>
                        <span>{it}</span>
                      </li>
                    ))}
                  </ul>
                );
              }
              if (b.type === "sub") {
                return (
                  <h3 key={i} className="mt-6 font-sans text-base font-semibold tracking-tight text-ink">
                    {b.text}
                  </h3>
                );
              }
              return (
                <p key={i} className="mt-4 text-sm md:text-base leading-relaxed text-mute">
                  {b.text.split("\n").map((line, k) => (
                    <span key={k}>
                      {line}
                      {k < b.text.split("\n").length - 1 && <br />}
                    </span>
                  ))}
                </p>
              );
            })}
          </FadeUp>
        ))}
      </div>
    </section>
  </main>
);
